import React, { useEffect, useRef } from "react";
import { ArtistItem } from "../topArtistList";

export const TrackItem = ({ data }) => {
  return (
    <div className="track-item">
      <img src={data.artwork} alt={data.name} className="track-item-cover" />

      <div>
        <p className="track-item-title">{data.name}</p>
        <p className="track-item-artist">{data.artistName}</p>
      </div>
    </div>
  );
};

export const SongListHorizontal = ({ songs }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      // Scroll to the second item (index 1)
      const secondItem = containerRef.current.children[0];
      secondItem.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, []);

  return (
    <div className="scroll-snap-container track-container" ref={containerRef}>
      <div className="spacer-small"></div>

      {songs &&
        songs.map((item, index) =>
          item ? <TrackItem key={index} data={item} /> : <div></div>
        )}
      <div className="spacer-small"></div>
    </div>
  );
};
